import { ClubModel } from '@modules/club/club-model';

const { fields } = ClubModel;

export default [
  fields.name,
  fields.logo,
  fields.teams,
];
